import React, { useState, useEffect } from "react";
import { Container, Typography, Paper, Dialog, MenuItem } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { getConcepts, addConcept, updateConcept, deleteConcept } from "../../services/firestore";

// PCS Admin React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// PCS Admin React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

function Concepts() {
  const [concepts, setConcepts] = useState([]);
  const [selected, setSelected] = useState(null);
  const [openForm, setOpenForm] = useState(false);
  const [formData, setFormData] = useState({
    nombre: "",
    periodicidad: "ninguna", // ninguna, mensual, anual
  });
  const [errors, setErrors] = useState({});

  const loadConcepts = async () => {
    try {
      const conceptsData = await getConcepts();
      setConcepts(conceptsData);
    } catch (error) {
      console.error("Error al cargar conceptos:", error);
    }
  };

  useEffect(() => {
    loadConcepts();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm("¿Está seguro de eliminar este concepto?")) {
      try {
        await deleteConcept(id);
        loadConcepts();
      } catch (error) {
        console.error("Error al eliminar concepto:", error);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.nombre.trim()) {
      setErrors({ nombre: "El nombre es requerido" });
      return;
    }

    try {
      if (selected) {
        await updateConcept(selected.id, formData);
      } else {
        await addConcept(formData);
      }
      setOpenForm(false);
      setFormData({ nombre: "", periodicidad: "ninguna" });
      setSelected(null);
      loadConcepts();
    } catch (error) {
      console.error("Error al guardar concepto:", error);
      setErrors({ submit: "Error al guardar el concepto" });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const columns = [
    { field: "nombre", headerName: "Nombre", flex: 1 },
    { 
      field: "periodicidad", 
      headerName: "Periodicidad", 
      flex: 1,
      valueGetter: (params) => {
        const periodicidad = params.row.periodicidad || "ninguna";
        const periodicidades = {
          ninguna: "Sin periodicidad",
          mensual: "Mensual",
          anual: "Anual"
        };
        return periodicidades[periodicidad];
      }
    },
    {
      field: "actions",
      headerName: "Acciones",
      flex: 1,
      renderCell: (params) => (
        <MDBox>
          <MDButton
            variant="gradient"
            color="info"
            size="small"
            onClick={() => {
              setSelected(params.row);
              setFormData({ 
                nombre: params.row.nombre,
                periodicidad: params.row.periodicidad || "ninguna"
              });
              setOpenForm(true);
            }}
            sx={{ mr: 1 }}
          >
            Editar
          </MDButton>
          <MDButton
            variant="gradient"
            color="error"
            size="small"
            onClick={() => handleDelete(params.row.id)}
          >
            Eliminar
          </MDButton>
        </MDBox>
      ),
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Container maxWidth="lg">
          <MDBox sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
            <Typography variant="h4">Conceptos</Typography>
            <MDButton
              variant="gradient"
              color="info"
              onClick={() => {
                setSelected(null);
                setFormData({ nombre: "", periodicidad: "ninguna" });
                setOpenForm(true);
              }}
            >
              Nuevo Concepto
            </MDButton>
          </MDBox>

          <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
            <DataGrid
              rows={concepts}
              columns={columns}
              pageSize={10}
              rowsPerPageOptions={[10]}
              autoHeight
              disableSelectionOnClick
            />
          </Paper>

          <Dialog open={openForm} onClose={() => setOpenForm(false)} maxWidth="sm" fullWidth>
            <MDBox component="form" onSubmit={handleSubmit} sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                {selected ? "Editar Concepto" : "Nuevo Concepto"}
              </Typography>
              <MDInput
                fullWidth
                label="Nombre"
                name="nombre"
                value={formData.nombre}
                onChange={handleChange}
                error={!!errors.nombre}
                helperText={errors.nombre}
                required
                sx={{ mb: 2 }}
              />
              <MDInput
                select
                fullWidth
                label="Periodicidad"
                name="periodicidad"
                value={formData.periodicidad}
                onChange={handleChange}
                sx={{ mb: 2 }}
              >
                <MenuItem value="ninguna">Sin periodicidad</MenuItem>
                <MenuItem value="mensual">Mensual</MenuItem>
                <MenuItem value="anual">Anual</MenuItem>
              </MDInput>
              {errors.submit && (
                <Typography color="error" sx={{ mb: 2 }}>
                  {errors.submit}
                </Typography>
              )}
              <MDButton variant="gradient" color="success" type="submit" fullWidth>
                {selected ? "Actualizar" : "Agregar"}
              </MDButton>
            </MDBox>
          </Dialog>
        </Container>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Concepts; 